/**
 * `<think>` blogu ayristirma - dosyadaki EN YUKSEK REGRESYON RISKLI mantik.
 *
 * Dort tolerans dalinin her biri GOZLENMIS bir basarisizlik yuzunden var:
 * 4B model bu formati duzenli olarak boziyor. Vanilla arayuzden (`app.js`)
 * aynen tasindi ve saf fonksiyona cevrildi ki test edilebilsin.
 *
 * Onceden bu mantik DOM manipulasyonuyla ic ice gecmisti; ayirmanin tek
 * amaci test edilebilirlik degil - ayni ayristirmanin hem canli akista hem
 * gecmisten yuklenen mesajlarda AYNI sonucu vermesini garanti etmek.
 */

export const THINK_OPEN = '<think>'
export const THINK_CLOSE = '</think>'

export interface ThinkSplit {
  /** Kullaniciya gosterilecek yanit. */
  answer: string
  /** Dusunme metni; yoksa null. */
  thinking: string | null
  /**
   * Model HALA dusunuyor mu (acilmis ama kapanmamis blok)?
   *
   * Arayuz bunu kullaniyor: caret dusunme kutusunun ICINDE yanip sonmeli,
   * yanit balonunda degil. Bu bayrak olmadan kullanici bos bir yanit
   * balonuna bakiyor ve uygulama donmus gibi gorunuyor.
   */
  streamingThought: boolean
}

/**
 * Uretilen metni (yanit, dusunme) olarak ayirir.
 *
 * Dallar:
 *  1. hic `<think>` yok            -> her sey yanit
 *  2. `<think>` var, `</think>` yok -> her sey dusunme, yanit HENUZ gelmedi
 *  3. normal durum                  -> ikisi ayrilir
 *  4. `</think>` sonrasi bos        -> dusunmeyi YANIT olarak kullan
 *
 * 4. dal kritik: model dusunup yanit yazmadiginda kullaniciya BOS balon
 * gostermek yerine dusunme metnini gosteriyoruz. Aksi halde "model hicbir
 * sey soylemedi" gibi gorunuyor.
 *
 * BIRDEN FAZLA blok olabilir: arac turlarinda her tur kendi `<think>`
 * blogunu aciyor. Tum bloklar dusunmeye, bloklarin ARASINDAKI ve
 * SONRASINDAKI metin yanita gidiyor - aksi halde ikinci turun dusunmesi yanit
 * balonunda ham etiketleriyle gorunuyor. ILK blogun ONCESINDEKI metin eskisi
 * gibi atiliyor (model bazen etiketten once gurultu yaziyor). Sunucudaki
 * `executor.py::split_thinking` AYNI kurali uyguluyor.
 */
export function splitThinking(text: string): ThinkSplit {
  if (!text.includes(THINK_OPEN)) {
    return { answer: text, thinking: null, streamingThought: false }
  }

  const thoughts: string[] = []
  const answerParts: string[] = []
  let openBlock = false
  let rest = text.slice(text.indexOf(THINK_OPEN) + THINK_OPEN.length)
  for (;;) {
    const closeAt = rest.indexOf(THINK_CLOSE)
    if (closeAt === -1) {
      // Dal 2: bu blok hala dusunuyor.
      thoughts.push(rest.trim())
      openBlock = true
      break
    }
    thoughts.push(rest.slice(0, closeAt).trim())
    rest = rest.slice(closeAt + THINK_CLOSE.length)
    const openAt = rest.indexOf(THINK_OPEN)
    if (openAt === -1) {
      answerParts.push(rest)
      break
    }
    answerParts.push(rest.slice(0, openAt))
    rest = rest.slice(openAt + THINK_OPEN.length)
  }

  const thinking = thoughts.filter(Boolean).join('\n\n') || null
  const answer = answerParts
    .map((part) => part.trim())
    .filter(Boolean)
    .join('\n\n')

  if (openBlock) {
    return { answer, thinking, streamingThought: true }
  }

  if (!answer && thinking) {
    // Dal 4: dusundu ama yanit yazmadi.
    return { answer: thinking, thinking: null, streamingThought: false }
  }

  return { answer, thinking, streamingThought: false }
}
